export class ViewBookingVM {
    totalNumberOfUnits: string;
    totalLandMeter: string;
    totalCubicMeter: string;
    freightRate: string;
    otherCharges: string
    baf: string;
    caf: string;
    thc: string;
    totalFreightCost: string
    costPerUnit: string;
    costPerCubicMeter: string;
    freightratevalidity: string;
    ratetotal: string
    baftotal: string
    caftotal: string;
    thctotal: string;
    otherchargestotal: string;
    totalsumofallcost:string;
}